/**
 * ANgular imports
 */
import {Component, OnInit} from 'angular2/core';
import {Router} from 'angular2/router';

/**
 * Node module imports
 */
import {TranslateService, TranslatePipe} from "ng2-translate";

/**
 * Service imports
 */
import {KeycloakService} from "../../../http/keycloak.service";

/**
 * Model imports
 */
import {User} from "../../../models/user.model";

@Component({
    selector: 'navbar',
    templateUrl: './app/components/layout/navbar/navbar.html',
    pipes: [TranslatePipe]
})
export class NavbarComponent implements OnInit {

    public currentUser: User;

    /**
     * @constructor
     * @param {KeycloakService} _keycloakService
     * @param {Router} _router
     * @param {TranslateService} _translateService
     */
    constructor(private _keycloakService: KeycloakService,
                private _router:Router,
                private _translateService:TranslateService) {
    }

    /**
     * @inheritDoc
     */
    public ngOnInit() {
        this.currentUser = this._keycloakService.getUser();
    }

    /**
     * Go to account management portal
     */
    public manageAccount() {
        this._keycloakService.manageAccount();
    }

    /**
     * Logout of the app
     */
    public logout() {
        this._keycloakService.logout();
    }

    /**
     * Change translation
     * @param {string} lang - new lang id
     */
    public changeLocale(lang) {
        window.localStorage.setItem("locale", lang);
        this._translateService.use(lang);
    }
}
